import { combineReducers } from 'redux';
import { reducer as addWorksheet } from '../ReduxViewModels/AddWorksheet';
import { reducer as admin } from '../ReduxViewModels/Admin';
import { reducer as agsExport } from '../ReduxViewModels/Ags/Export';
import { reducer as agsProjectExport } from '../ReduxViewModels/Ags/Project';
import { reducer as agsValidationErrorMessages } from '../ReduxViewModels/Ags/ValidationError';
import { reducer as agsWorkOrderExport } from '../ReduxViewModels/Ags/WorkOrder';
import { reducer as agsWorkOrderList } from '../ReduxViewModels/Ags/WorkOrderGrid';
import { reducer as app } from '../ReduxViewModels/App';
import { reducer as assignedMaximumDryDensityTests } from '../ReduxViewModels/AssignedValuesTests';
import { reducer as authentication } from '../ReduxViewModels/Authentication';
import { reducer as barcode } from '../ReduxViewModels/Barcode';
import { reducer as environment } from '../ReduxViewModels/Environment';
import { reducer as equipment } from '../ReduxViewModels/Equipment';
import { reducer as equipmentInterfacing } from '../ReduxViewModels/EquipmentInterfacing';
import gridScrollLink from '../ReduxViewModels/GridScrollLink/reducers';
import { reducer as images } from '../ReduxViewModels/Images';
import importedWorksheet from '../ReduxViewModels/ImportedWorksheet/reducers';
import { reducer as interLab } from '../ReduxViewModels/InterLab';
import { reducer as lists } from '../ReduxViewModels/Lists';
import { reducer as messageLink } from '../ReduxViewModels/MessageLink';
import { reducer as notices } from '../ReduxViewModels/Notices';
import { reducer as gaugeStandardisation } from '../ReduxViewModels/NuclearGaugeStandardisation';
import { reducer as pageSections } from '../ReduxViewModels/PageSections';
import { reducer as plateLoading } from '../ReduxViewModels/PlateLoading';
import { reducer as psdHydrometer } from '../ReduxViewModels/PsdHydrometer';
import { reducer as psdSieveAnalysis } from '../ReduxViewModels/PsdSieveAnalysis';
import { reducer as searchWorksheets } from '../ReduxViewModels/SearchWorksheets';
import { reducer as serviceSetup } from '../ReduxViewModels/ServiceSetup';
import settings from '../ReduxViewModels/Settings/reducers';
import { reducer as testPages } from '../ReduxViewModels/TestPages';
import { reducer as user } from '../ReduxViewModels/User';
import { reducer as worksheetBatchUpdate } from '../ReduxViewModels/WorksheetBatchUpdate';
import { reducer as worksheetEditor } from '../ReduxViewModels/WorksheetEditor';
import { reducer as worksheetGrid } from '../ReduxViewModels/WorksheetGrid';
import { clearState } from './actions';

const combinedReducer = combineReducers({
  agsExport,
  worksheetEditor,
  authentication,
  lists,
  gridScrollLink,
  user,
  settings,
  importedWorksheet,
  searchWorksheets,
  admin,
  equipment,
  psdSieveAnalysis,
  psdHydrometer,
  plateLoading,
  assignedMaximumDryDensityTests,
  serviceSetup,
  worksheetGrid,
  worksheetBatchUpdate,
  addWorksheet,
  environment,
  messageLink,
  pageSections,
  equipmentInterfacing,
  agsWorkOrderExport,
  agsWorkOrderList,
  agsProjectExport,
  agsValidationErrorMessages,
  notices,
  testPages,
  app,
  interLab,
  barcode,
  images,
  gaugeStandardisation,
});

const rootReducer = (state: any, action: any) => {
  // This will clear the entire state except for the white listed items that we wish to keep.
  // This is used for security purposes such as when the user logs out
  if (clearState.match(action)) {
    const {
      serviceSetup,
      authentication: {
        entra: { autoLogin },
      },
    } = state;
    state = { serviceSetup, authentication: { entra: { autoLogin } } };
  }

  return combinedReducer(state, action);
};

export default rootReducer;
